/**
 * DTN · Carrito lateral (overlay translúcido + upsell)
 * Desarrollado por DominandoTuNegocio.cl
 */
import { CartLinesUpdateEvent } from '@shopify/events';

const WIDE = window.matchMedia('(min-width: 990px)');

const getCartDrawer = () => document.getElementById('cart-drawer');
const getPageWrapper = () => document.querySelector('.page-wrapper');

/** En escritorio el carrito no empuja la página: se superpone sobre el velo. */
function unsqueeze() {
  const cartDrawer = getCartDrawer();
  if (!cartDrawer?.hasAttribute('open')) return;
  const others = [...document.querySelectorAll('theme-drawer[open]')].filter((d) => d !== cartDrawer);
  if (others.length === 0) getPageWrapper()?.classList.remove('page-wrapper--drawer-open');
}

if (!window.__dtnCartReady) {
  window.__dtnCartReady = true;

  document.addEventListener('theme-drawer:open', () => queueMicrotask(unsqueeze));
  WIDE.addEventListener('change', () => queueMicrotask(unsqueeze));
  unsqueeze();

  // El carrito no se restaura abierto al navegar (evita el velo encendido al cargar)
  try {
    const stored = (sessionStorage.getItem('theme-drawer-open') || '').split(',').filter((id) => id && id !== 'cart-drawer');
    stored.length ? sessionStorage.setItem('theme-drawer-open', stored.join(',')) : sessionStorage.removeItem('theme-drawer-open');
  } catch (e) {}

  document.addEventListener('click', (event) => {
    const target = /** @type {Element} */ (event.target);

    if (target.closest?.('[data-dtn-cart-scrim]')) {
      getCartDrawer()?.close?.();
      return;
    }

    const button = target.closest?.('[data-dtn-upsell-add]');
    if (button) addUpsell(/** @type {HTMLButtonElement} */ (button));
  });
}

/** @param {HTMLButtonElement} button */
async function addUpsell(button) {
  if (button.dataset.state === 'loading' || button.dataset.state === 'added') return;

  const variantId = button.dataset.variantId;
  if (!variantId) return;

  button.dataset.state = 'loading';
  button.disabled = true;

  const sectionIds = [...document.querySelectorAll('cart-items-component')]
    .map((el) => /** @type {HTMLElement} */ (el).dataset.sectionId)
    .filter(Boolean);

  const deferred = CartLinesUpdateEvent.createPromise();
  button.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity: 1 }],
      promise: deferred.promise,
    })
  );

  const routes = window.Theme?.routes || {};
  const addUrl = routes.cart_add_url || '/cart/add.js';
  const cartUrl = `${routes.cart_url || '/cart'}.json`;

  try {
    const response = await fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sectionIds.join(',') }),
    });
    const data = await response.json();

    const cart = await fetch(cartUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then((r) =>
      r.json()
    );

    if (data.status) {
      deferred.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: { didError: true, items: cart.items, source: 'dtn-cart-upsell' },
      });
      fail(button);
      return;
    }

    button.dataset.state = 'added';
    // Pequeña pausa para que se vea el check antes de que el carrito se actualice
    await new Promise((resolve) => setTimeout(resolve, 450));

    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'dtn-cart-upsell',
        sections: data.sections,
        didError: false,
      },
    });
  } catch (error) {
    deferred.reject(error);
    fail(button);
  }
}

/** @param {HTMLButtonElement} button */
function fail(button) {
  button.dataset.state = 'error';
  setTimeout(() => {
    button.removeAttribute('data-state');
    button.disabled = false;
  }, 900);
}
